import React from 'react';

import { MODAL_NAMES } from '@constants/modalRenderers';

import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import { useUserDeleteMutation } from '@services/user/useUserDeleteMutation';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

const DeleteUserBtn = ({ user }) => {
  const { t } = useTranslation();

  const { setSecondaryModal, setModalClose } = useModalActions();

  const { mutate: userDeleteMutationMutation } = useUserDeleteMutation();

  const handleDeleteUser = () => {
    setSecondaryModal({
      name: MODAL_NAMES.modalConfirm,
      options: {
        bodyTitle: t('Delete User'),
        bodyContent: (
          <>
            {t('Are you sure you want to delete this user?')}
            <div className={style.deleteUser}>
              <img src={user?.userpic} className={style.deleteUserImg} alt="avatar" />
              <span className={style.deleteUserName}>{user?.full_name}</span>
            </div>
          </>
        ),
        onConfirm: () =>
          userDeleteMutationMutation(
            { id: user?.id },
            {
              onSuccess: (result) => {
                const resultStatus = result.data?.status === 'ok';
                showToast({
                  variant: resultStatus ? 'success' : 'error',
                  message: resultStatus ? t('User successfully deleted') : result.data.message,
                });

                setModalClose();
              },
            },
          ),
      },
    });
  };

  return (
    <div className={style.userStepsDeleteBtn} onClick={handleDeleteUser}>
      {t('Delete User')}
    </div>
  );
};

export default DeleteUserBtn;
